<template>
  <div class="modify-form">
    <form id="myform">
      <div class="form-group">
        <span class="show-pwd" @click="showPwd('isShowPwd1')">
          <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd1" alt="">
          <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd1" alt="">
        </span>
        <input
          v-if="isShowPwd1"
          type="text"
          name="password"
          :placeholder="placeholderGroup.oldPassword"
          v-model.trim="form.password"
          v-validate="'required'"
          @blur="showError.oldPassword = true"
          :class="{'danger-border': form.oldPassword && errors.has('password') || !!pwdErrorMessage}"
        />
        <input
          v-if="!isShowPwd1"
          type="password"
          name="password"
          :placeholder="placeholderGroup.oldPassword"
          v-model.trim="form.password"
          v-validate="'required'"
          @blur="showError.oldPassword = true"
          :class="{'danger-border': form.oldPassword && errors.has('password') || !!pwdErrorMessage}"
        />
        <p class="error-info">
          <span v-show="errors.has('password') && showError.oldPassword">{{ errors.first('password') }}</span>
          <span>{{ pwdErrorMessage }}</span>
        </p>
      </div>

      <div class="form-group">
        <span class="show-pwd" @click="showPwd('isShowPwd2')">
          <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd2" alt="">
          <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd2" alt="">
        </span>
        <input autocomplete="off"
          v-if="isShowPwd2"
          type="text"
          name="newPassword"
          :placeholder="placeholderGroup.newPassword"
          v-model.trim="form.newPassword"
          v-validate="'required|min:6|max:20'"
          @blur="showError.newPassword = true"
          :class="{'danger-border': errors.has('newPassword') && showError.newPassword}"
        />
        <input autocomplete="off"
          v-if="!isShowPwd2"
          type="password"
          name="newPassword"
          :placeholder="placeholderGroup.newPassword"
          v-model.trim="form.newPassword"
          v-validate="'required|min:6|max:20'"
          @blur="showError.newPassword = true"
          :class="{'danger-border': errors.has('newPassword') && showError.newPassword}"
        />
        <p class="error-info">
          <span v-show="showError.newPassword">{{ errors.first('newPassword') }}</span>
        </p>
      </div>

      <div class="form-group">
        <span class="show-pwd" @click="showPwd('isShowPwd3')">
          <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd3" alt="">
          <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd3" alt="">
        </span>
        <input autocomplete="off"
          v-if="isShowPwd3"
          type="text"
          name="confirmPassword"
          :placeholder="placeholderGroup.confirmPassword"
          v-model.trim="form.confirmation"
          v-validate="'required|confirmed:newPassword|min:6|max:20'"
          @keyup.enter="doModify"
          @blur="showError.confirmPassword = true"
          :class="{'danger-border': errors.has('confirm') && showError.confirmPassword}"
        />
        <input autocomplete="off"
          v-if="!isShowPwd3"
          type="password"
          name="confirmPassword"
          :placeholder="placeholderGroup.confirmPassword"
          v-model.trim="form.confirmation"
          v-validate="'required|confirmed:newPassword|min:6|max:20'"
          @keyup.enter="doModify"
          @blur="showError.confirmPassword = true"
          :class="{'danger-border': errors.has('confirm') && showError.confirmPassword}"
        />
        <p class="error-info">
          <span v-show="showError.confirmPassword">{{ errors.first('confirm') }}</span>
        </p>
      </div>

      <button type="button" class="form-submit" @click="doModify" v-if="!isLoading">
        <span>{{ $t('sureCommit') }}</span>
      </button>
      <spinner :show="isLoading" class="spinner-component"></spinner>
    </form>
  </div>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import locales from './lang.js';
import { SET_USER_INFO } from '../../store/mutation-types';

export default {
  name: 'modify-password-view',
  components: { Spinner },
  data: function () {
    return {
      isLoading: false,
      isShowPwd1: false,
      isShowPwd2: false,
      isShowPwd3: false,
      form: {
        password: '',
        newPassword: '',
        confirmation: '',
        oldPassword: false
      },
      pwdErrorMessage: '',
      successPromptMessage: '',
      placeholderGroup: {
        oldPassword: this.$t('oldPassword'),
        newPassword: this.$t('newPassword'),
        confirmPassword: this.$t('confirmPassword')
      },
      networkError: this.$t('networkError'),
      modifyPasswordSuccess: this.$t('modifyPasswordSuccess'),
      showError: {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
      }
    };
  },
  watch: {
    'form.password': {
      handler() {
        this.showError.oldPassword = false;
      },
      deep: true
    },
    'form.newPassword': {
      handler() {
        this.showError.newPassword = false;
      },
      deep: true
    },
    'form.confirmation': {
      handler() {
        this.showError.confirmPassword = false;
      },
      deep: true
    }
  },
  locales,
  created() {
    this.defaultForm = JSON.parse(JSON.stringify(this.form));
    this.defaultShowError = JSON.parse(JSON.stringify(this.showError));
    this.form.oldPassword = true;
  },
  methods: {
    showPwd: function (showSpan) {
      this[showSpan] = !this[showSpan];
    },
    doModify: function () {
      if (this.errors.errors.length > 0) {
        return;
      }
      let temp = this;
      this.$validator.validateAll().then(success => {
        if (!success) {
          return;
        }
        for (let i in temp.showError) {
          temp.showError[i] = true;
        }
        temp.pwdErrorMessage = '';
        this.isLoading = true;
        new Promise((resolve, reject) => {
          this.$http
            .patch('api/password/change', {
              old_password: this.form.password,
              new_password: this.form.newPassword
            })
            .then(
              response => {
                if (response.data.code === 0) {
                  resolve(response.data.code);
                } else {
                  this.pwdErrorMessage = response.data.message;
                }
                this.isLoading = false;
              },
              response => {
                this.isLoading = false;
                this.pwdErrorMessage = this.networkError;
              }
            );
        }).then(code => {
          if (code === 0) {
            this.successPromptMessage = this.modifyPasswordSuccess;
            this.$emit('doModify', this.successPromptMessage);
            Object.assign(this.form, this.defaultForm);
            Object.assign(this.showError, this.defaultShowError);
            if (this.$store.state.user['email']) {
              this.$http
                .post('api/login', {
                  email: this.$store.state.user['email'],
                  password: this.form.newPassword
                })
                .then(response => {
                  if (response.data.code === 0) {
                    window.localStorage.setItem('token', response.data.data.access_token);
                    this.$store.commit(SET_USER_INFO, response.data.data);
                    this.$router.push('/modify');
                  }
                });
            } else {
              this.$http
                .post('api/phone-login', {
                  calling_code: this.$store.state.user['calling_code'],
                  phone_num: this.$store.state.user['phone_num'],
                  password: this.form.newPassword
                })
                .then(response => {
                  if (response.data.code === 0) {
                    window.localStorage.setItem('token', response.data.data.access_token);
                    this.$store.commit(SET_USER_INFO, response.data.data);
                    this.$router.push('/modify');
                  }
                });
            }
          }
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../assets/scss/variables';
@import '../../assets/scss/formstyle';

div.form-group {
  input{
    background-color: transparent;
    color: #111;
    border-bottom: 1px solid #E0D7E3;
  }
  input::-webkit-input-placeholder{
    color: #999;
  }
}

.form-submit {
  width: 260px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #416CF8;
  border-radius: 20px;
  color: #416CF8;
  font-size: .16rem;
  background: #fff;
  @media screen and (max-width: 767px) {
    height: 48px;
    line-height: 48px;
    border-radius: 100px;
    margin-top: .2rem;
  }
}
</style>



// WEBPACK FOOTER //
// ModifyPassword.vue?609f1a1e